import styles from "./addButton.module.css";

interface IAddButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  additionalClassName?: string;
  title: string;
  disabled?: boolean;
  tooltip?: string;
}
function AddButton({ onClick, additionalClassName, title, disabled, tooltip }: IAddButtonProps) {
  return (
    <button
      type="button"
      className={`addBtn ${additionalClassName}`}
      onClick={onClick}
      data-testid="add-button"
      disabled={disabled}
      title={tooltip}
    >
      <span className={styles.btn__plus}>+</span>
      {title}
    </button>
  );
}

export default AddButton;
